module.exports = __webpack_public_path__ + "img/gis系统_xz.c9dfe0ca.jpg";